import {
  EmailSchema,
  PagingSchema,
  PushSchema,
  SmsSchema,
  createDetailResponseSchema,
  createListResponseSchema,
  createListResponseSchemaDefault,
} from 'src/feature/bite/domain'
import z from 'zod'

export const SegmentSchema = z.object({
  macroSegment: z.string(),
  microSegment: z.string(),
  demographicInfos: z.any(),
  behavioralSegments: z.any(),
})

export const AddressSchema = z.object({
  buildingNo: z.string(),
  zipCode: z.string(),
  region: z.string(),
  city: z.string(),
  country: z.string(),
  addressLine: z.string(),
})

export const ConsentSchema = z.object({
  termsAndConditions: z.boolean().optional(),
  email: z.boolean(),
  sms: z.boolean(),
  push: z.boolean(),
})

export const TransactionSchema = z.object({
  orderId: z.string().nullable(),
  transactionId: z.string().nullable(),
  date: z.string(),
  type: z.any(),
  paidAmount: z.any(),
  totalAmount: z.any(),
  discountAmount: z.any(),
  channel: z.any(),
  posNo: z.string().nullable(),
  storeNo: z.string().nullable(),
})

export const MemberSchema = z.object({
  middleName: z.string().nullable(),
  surname: z.string(),
  totalEarnings: z.number(),
  gender: z.number(),
  birthDate: z.string().nullable(),
  customerToken: z.string(),
  externalMemberId: z.string(),
  preferredLanguage: z.string(),
  secondLanguage: z.string(),
  memberId: z.string(),
  name: z.string(),
  netPoints: z.number(),
  worth: z.number(),
  savings: z.number(),
  mobile: z.string().nullable(),
  email: z.string().nullable(),
  enrollmentDate: z.string(),
  status: z.number(),
  storeName: z.string(),
  storeId: z.string(),
  customerGroup: z.string(),
})

export const MemberDetailSchema = z.object({
  birthDate: z.string().nullable(),
  customerGroup: z.string(),
  customerToken: z.string(),
  email: z.string(),
  enrollmentDate: z.string(),
  externalMemberId: z.string(),
  id: z.string(),
  memberId: z.string(),
  mobile: z.string(),
  name: z.string().nullable(),
  netPoints: z.number(),
  referedCustomerCode: z.string().nullable(),
  referedCustomerID: z.string().nullable(),
  referralCode: z.string().nullable(),
  savings: z.number(),
  status: z.number(),
  surname: z.string().nullable(),
  totalEarnings: z.number(),
  vipTier: z.string().nullable(),
  worth: z.number(),
})

export const MemberTabSchema = z.object({
  Consent: ConsentSchema.optional(),
  Segment: SegmentSchema.optional(),
  Address: z.object({dataList: AddressSchema.array(), paging: PagingSchema}).optional(),
  Transaction: z.object({dataList: TransactionSchema.array(), paging: PagingSchema}).optional(),
  // Engagement
  SmsEngagement: z.object({dataList: SmsSchema.array(), paging: PagingSchema}).optional(),
  PushEngagement: z.object({dataList: PushSchema.array(), paging: PagingSchema}).optional(),
  EmailEngagement: z.object({dataList: EmailSchema.array(), paging: PagingSchema}).optional(),
})

export const Responses = {
  Segment: createDetailResponseSchema(SegmentSchema),
  // Address: createDetailResponseSchema(z.object({ addresses: AddressSchema.array() })),
  Address: createListResponseSchema(AddressSchema.array()),
  Consent: createDetailResponseSchema(ConsentSchema),
  Transaction: createListResponseSchema(TransactionSchema.array()),
  SmsEngagement: createListResponseSchemaDefault(
    z.object({
      emails: EmailSchema.array(),
      pushes: PushSchema.array(),
      textMessages: SmsSchema.array(),
      listPaging: PagingSchema,
    })
  ),
  PushEngagement: createListResponseSchemaDefault(
    z.object({
      emails: EmailSchema.array(),
      pushes: PushSchema.array(),
      textMessages: SmsSchema.array(),
      listPaging: PagingSchema,
    })
  ),
  EmailEngagement: createListResponseSchemaDefault(
    z.object({
      emails: EmailSchema.array(),
      pushes: PushSchema.array(),
      textMessages: SmsSchema.array(),
      listPaging: PagingSchema,
    })
  ),
}

export const MemberSchemaResponse = createDetailResponseSchema(
  z
    .object({
      member: MemberDetailSchema,
    })
    .nullable()
)

export type MemberTab = z.infer<typeof MemberTabSchema>

export type Member = z.infer<typeof MemberSchema>
export type MemberDetail = z.infer<typeof MemberDetailSchema>
export type MemberResponse = z.infer<typeof MemberSchemaResponse>
